/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetNewRemoteSessionClientCallbackUrlSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetNewRemoteSessionClientCallbackUrlSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetNewRemoteSessionClientCallbackUrlSecurity = {
  option1?: GetNewRemoteSessionClientCallbackUrlSecurityOption1 | undefined;
  option2?: GetNewRemoteSessionClientCallbackUrlSecurityOption2 | undefined;
};

export type GetNewRemoteSessionClientCallbackUrlRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetNewRemoteSessionClientCallbackUrlSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetNewRemoteSessionClientCallbackUrlSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetNewRemoteSessionClientCallbackUrlSecurityOption1$Outbound,
    GetNewRemoteSessionClientCallbackUrlSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getNewRemoteSessionClientCallbackUrlSecurityOption1ToJSON(
  getNewRemoteSessionClientCallbackUrlSecurityOption1:
    GetNewRemoteSessionClientCallbackUrlSecurityOption1,
): string {
  return JSON.stringify(
    GetNewRemoteSessionClientCallbackUrlSecurityOption1$outboundSchema.parse(
      getNewRemoteSessionClientCallbackUrlSecurityOption1,
    ),
  );
}

/** @internal */
export type GetNewRemoteSessionClientCallbackUrlSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetNewRemoteSessionClientCallbackUrlSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetNewRemoteSessionClientCallbackUrlSecurityOption2$Outbound,
    GetNewRemoteSessionClientCallbackUrlSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getNewRemoteSessionClientCallbackUrlSecurityOption2ToJSON(
  getNewRemoteSessionClientCallbackUrlSecurityOption2:
    GetNewRemoteSessionClientCallbackUrlSecurityOption2,
): string {
  return JSON.stringify(
    GetNewRemoteSessionClientCallbackUrlSecurityOption2$outboundSchema.parse(
      getNewRemoteSessionClientCallbackUrlSecurityOption2,
    ),
  );
}

/** @internal */
export type GetNewRemoteSessionClientCallbackUrlSecurity$Outbound = {
  Option1?:
    | GetNewRemoteSessionClientCallbackUrlSecurityOption1$Outbound
    | undefined;
  Option2?:
    | GetNewRemoteSessionClientCallbackUrlSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const GetNewRemoteSessionClientCallbackUrlSecurity$outboundSchema:
  z.ZodMiniType<
    GetNewRemoteSessionClientCallbackUrlSecurity$Outbound,
    GetNewRemoteSessionClientCallbackUrlSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetNewRemoteSessionClientCallbackUrlSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetNewRemoteSessionClientCallbackUrlSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getNewRemoteSessionClientCallbackUrlSecurityToJSON(
  getNewRemoteSessionClientCallbackUrlSecurity:
    GetNewRemoteSessionClientCallbackUrlSecurity,
): string {
  return JSON.stringify(
    GetNewRemoteSessionClientCallbackUrlSecurity$outboundSchema.parse(
      getNewRemoteSessionClientCallbackUrlSecurity,
    ),
  );
}

/** @internal */
export type GetNewRemoteSessionClientCallbackUrlRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetNewRemoteSessionClientCallbackUrlRequest$outboundSchema:
  z.ZodMiniType<
    GetNewRemoteSessionClientCallbackUrlRequest$Outbound,
    GetNewRemoteSessionClientCallbackUrlRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function getNewRemoteSessionClientCallbackUrlRequestToJSON(
  getNewRemoteSessionClientCallbackUrlRequest:
    GetNewRemoteSessionClientCallbackUrlRequest,
): string {
  return JSON.stringify(
    GetNewRemoteSessionClientCallbackUrlRequest$outboundSchema.parse(
      getNewRemoteSessionClientCallbackUrlRequest,
    ),
  );
}
